// @flow
import { useEffect } from 'react';
import { connect } from 'react-redux';
import type { CurrentHistoryEntry } from 'app/common/redux/reducers/history';
import type { HistoryLocation } from 'app/common/redux/actions/history';
import { type Action } from 'app/common/redux/actions/types';
import { type Dispatch } from 'redux';
import { type State as ReduxState } from 'app/common/redux/types';
import {
  getPinIdsFromItems,
  setRoutePins as setRoutePinsAction,
} from 'app/common/redux/actions/routePins';

type OwnProps = {|
  items: Array<Object>,
|};

type ReduxStateProps = {|
  currentHistoryEntry: ?CurrentHistoryEntry,
|};

type ReduxDispatchProps = {|
  setRoutePins: (pinIds: Array<string>, location: HistoryLocation) => Object,
|};

type Props = {|
  ...ReduxStateProps,
  ...ReduxDispatchProps,
  ...OwnProps,
|};

const useSaveRoutePins = ({ items, currentHistoryEntry, setRoutePins }: Props) => {
  useEffect(
    () => {
      if (items && setRoutePins && currentHistoryEntry) {
        setRoutePins(getPinIdsFromItems(items), currentHistoryEntry.location);
      }
    },
    [items], // only enter when reference to the items array is changed
  );
};

function SaveRoutePins(props: Props) {
  useSaveRoutePins(props);
  return null;
}

const mapStateToProps = ({ history }: ReduxState): ReduxStateProps => ({
  currentHistoryEntry: history.current,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>): ReduxDispatchProps => ({
  setRoutePins: (pinIds: Array<string>, location: HistoryLocation) =>
    dispatch(setRoutePinsAction(pinIds, location)),
});

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps,
)(SaveRoutePins);
